export { default } from "./BranchLocalizations";
